<template>
    <div
        class="ImageText"
        :class="{'ImageText--rev' : alignment}"
    >
        <BaseImage
            v-if="image"
            classes="BaseImage--ImageText"
            :placeholder="placeholder"
            :srcset="image"
            :ratio="1"
        />

        <div
            class="ImageText__text">

            <BaseHeading
                v-if="heading"
                :heading="heading"
                :preheading="preheading"
                tag="h3"
                class="text--white noline"
            />

            <BaseText
                :text="text"
                class="text--white mt-spacer mb-medium"
            />

            <BaseButton
                v-if="button"
                :href="url"
                modifier="ghost"
            >
                {{ button }}
            </BaseButton>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ImageText',
    props: {
        heading: {
            type: String,
            default: null,
        },
        preheading: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        image: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        alignment: {
            type: Boolean,
            default: false
        },
        button: {
            type: String,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
    }
}
</script>
<style lang="scss">
    .ImageText {
        display: flex;
        flex-direction: column-reverse;

        @include media-query(lap-and-up) {
            flex-direction: row;
        }
    }

    .ImageText--rev, .ImageText--white {
        flex-direction: row-reverse;

        @include media-query(palm) {
            flex-direction: column;
        }
    }

    .ImageText__text {
        padding: 3rem getSpacing('medium');
        background-color: getColour('blue');

        @include media-query(lap-and-up) {
            width: 50%;
        }

        @include media-query(desk) {
            padding: getSpacing('large');
            padding-top: getSpacing('xlarge');
        }

        .ImageText--white & {
            background: getColour('white');
        }
    }

    .ImageText .BaseButton {
        margin-top: 0.5rem;
    }

    .ImageText .wysiwyg {
        ul li:before {
            background-color: getColor('white');
        }

        ol li:before {
            color: getColor('white');
        }
    }

    .ImageTextIndustry .BaseImage {
        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: url('../assets/images/wonder.svg');
            background-size: 50%;
            background-position: center;
            background-repeat: no-repeat;
            z-index: 1;
        }
    }
</style>
